/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import {
  Platform,
  NavParams,
  NavController,
  AlertController,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonContent,
  IonCard,
  IonCardContent,
  IonItem,
  IonInput,
  IonText,
  IonLabel,
  IonTextarea,
  IonListHeader,
  IonSelect,
  IonSelectOption,
  IonList,
  IonRadioGroup,
  IonRadio,
  IonRow,
  IonCol,
  IonButton,
} from '@ionic/angular/standalone';
import { Storage } from '@ionic/storage';
import { GroupServices } from '../../../providers/group-services';
import {
  TranslateService,
  TranslatePipe
} from '@ngx-translate/core';
import { GoogleAnalyticsService } from 'src/app/providers/google-analytics.service';
import { LanguageProvider } from '../../../providers/language';
import { Globalization } from '@awesome-cordova-plugins/globalization/ngx';
import { AdsServicesService } from 'src/app/providers/ads-services.service';
import { Router } from '@angular/router';
import { GlobalDataService } from 'src/app/providers/global-data.service';
import { ModalController } from '@ionic/angular/standalone';
import { common } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { CommonModule, NgFor } from '@angular/common';

@Component({
  selector: 'app-club-add',
  templateUrl: './club-add.page.html',
  styleUrls: ['./club-add.page.scss'],
  standalone:true,
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonContent,
    IonCard,
    IonCardContent,
    IonItem,
    IonInput,
    FormsModule,
    IonText,
    IonLabel,
    IonTextarea,
    IonListHeader,
    IonSelect,
    NgFor,
    IonSelectOption,
    IonList,
    IonRadioGroup,
    IonRadio,
    IonRow,
    IonCol,
    IonButton,
    TranslatePipe,
    CommonModule,
  ],
})
export class ClubAddPage implements OnInit {
  agentId: number;
  newGroupId: number;
  agent: any;
  groupType: string;
  groupName: string;
  groupDesc: string;
  collectionCountries: any;
  deviceCountry: any;
  selectedCountry: any;

  constructor(
    public modalCtrl: ModalController,
    private navCtrl: NavController,
    private navParams: NavParams,
    private ads: AdsServicesService,
    private platform: Platform,
    private gaService: GoogleAnalyticsService,
    private gds: GlobalDataService,
    private router: Router,
    //              private events: Events,
    public localStorage: Storage,
    private langProvider: LanguageProvider,
    private groupServices: GroupServices,
    private globalization: Globalization,
    public translate: TranslateService,
    //              public viewCtrl: ViewController,
    public alertCtrl: AlertController
  ) {
    void this.gaService.trackPageView('group_add_page');

    
  }

  async ngOnInit() {
    // this.langProvider.getAppLocalesList().subscribe(
    //   (countries: any) => {
    //     this.collectionCountries = countries.resource;
    //   },
    //   (error) => {
    //     this.translate.use('en'.toLowerCase());
    //     console.log('Error starting GoogleAnalytics', error);
    //   }
    // );

    try {
      const countries: any = await this.langProvider.getAppLocalesList();
      this.collectionCountries = countries.resource;
    } catch (error) {
      this.translate.use('en'.toLowerCase());
      console.log('Error starting GoogleAnalytics', error);
    }

    this.gds.getAgent().subscribe((data) => {
      console.log('receiving agent data from GDS');
      console.log('agent is:');
      console.log(data);
      if (data !== undefined && data !== null) {
        this.agent = data;
        this.agentId = data.AGENT_ID;
        this.selectedCountry = data.country_cca2;
      }
    });
  }

  ionViewWillEnter() {
    this.globalization.getLocaleName().then((res) => {
      console.log('getLocaleNameRes' + res);
      this.deviceCountry = res.value.substr(res.value.length - 2);
      this.selectedCountry = this.deviceCountry;
    });
  }

  dismiss() {
    //this.router.navigateByUrl('/clubs');
    this.modalCtrl.dismiss();
    //    this.viewCtrl.dismiss();
  }

  onChangeCountry() {}

  async createNewGroup() {
    console.log('In createNewGroup()');
    console.log('groupName:' + this.groupName);
    if (this.groupName == '' || this.groupName === undefined) {
      let alert = await this.alertCtrl.create({
        header: this.translate.instant('GROUP_NAME_EMPTY'),
        subHeader: this.translate.instant('PLEASE_FILL_GROUP_NAME'),
        buttons: [this.translate.instant('ADD_ENTRY_CANCEL')],
        cssClass: 'alert-buttons',
      });
      alert.present();
      return;
    }
    console.log('groupDesc:' + this.groupDesc);
    if (this.groupDesc == '' || this.groupDesc === undefined) {
      let alert = await this.alertCtrl.create({
        header: this.translate.instant('GROUP_DESCRIPTION_EMPTY'),
        subHeader: this.translate.instant('PLEASE_FILL_GROUP_DESCRIPTION'),
        buttons: [this.translate.instant('ADD_ENTRY_CANCEL')],
        cssClass: 'alert-buttons',
      });
      alert.present();
      return;
    }
    console.log("groupType:" + this.groupType)

    //this.groupServices.createNewGroup(this.agentId, this.groupType, this.groupName, this.groupDesc, this.selectedCountry)
    //  .subscribe( (newGroupId: any)=> {
    //    this.newGroupId = newGroupId.resource[0].GROUP_ID;
    //    console.log('Grupo criado.... adicionar na CRM_AGENT_GROUP...' + this.newGroupId)
//
    //    this.groupServices.addAgentToGroup( this.agentId.toString(), this.newGroupId.toString(), 4)
    //      .subscribe( ()=> {
    //          console.log('Adicionado na CRM_AGENT_GROUP')
    //          if (this.platform.is('cordova')) {
    //            this.ga.trackEvent('group_add_page', 'create_group', 'success', 1).then(() => {});
    //          }
//
    //          this.ads.evtShowInterstitialAdd('G');
    //          this.dismiss();
    //        },
    //        (err) => {
    //          if (this.platform.is('cordova')) {
    //            this.ga.trackEvent('group_add_page', 'create_group', 'success', 1).then(() => {});
    //          }
    //          console.log(err);
    //        }
    //      )
    //    },
    //  (err) => { console.log(err) }
    //)

    this.groupServices.createNewGroup(this.agentId, this.groupType, this.groupName, this.groupDesc, this.selectedCountry)
    .then((newGroupResponse: any) => {
      this.newGroupId = newGroupResponse.resource[0].GROUP_ID;
      console.log('Grupo criado.... adicionar na CRM_AGENT_GROUP...', this.newGroupId);

      return this.groupServices.addAgentToGroup(this.agentId.toString(), this.newGroupId.toString(), 4);
    })
    .then(() => {
      console.log('Adicionado na CRM_AGENT_GROUP');

      void this.gaService.trackEvent('group_add_page', 'create_group', 'success', 1);

      this.ads.evtShowInterstitialAdd('G');
      this.dismiss();
    })
    .catch((err) => {
      console.log('Error in group creation process:', err);

      void this.gaService.trackEvent('group_add_page', 'create_group', 'failure', 0);
    });

    this.modalCtrl.dismiss();
  }
}
